import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

import type { GetAdminV1OrgAuditLogsParams } from '@nucleus-commerce/api-client/admin';

import { activityApi } from '../api/activity-api';

export type ActivityParams = Omit<GetAdminV1OrgAuditLogsParams, 'cursor'>;

export const activityKeys = {
  all: ['org', 'audit-logs'] as const,
  list: (params: ActivityParams) => [...activityKeys.all, params] as const,
};

/** A log reads top to bottom, so it pages with "load more" rather than next/previous. */
export function activityQueryOptions(params: ActivityParams) {
  return infiniteQueryOptions({
    queryKey: activityKeys.list(params),
    queryFn: ({ pageParam }) =>
      activityApi.list({ ...params, ...(pageParam ? { cursor: pageParam } : {}) }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
}

export function useActivity(params: ActivityParams) {
  return useInfiniteQuery(activityQueryOptions(params));
}
